export const SPOTLIGHT_EVENTS = {
	PROFILE_ACCOUNT_TYPE_SELECTED: "profile.accountTypeSelected",
	PROFILE_ACCOUNT_TYPE_CHANGE_CANCELLED: "profile.accountTypeChangeCancelled",
	PROFILE_ACCOUNT_TYPE_CHANGED: "profile.accountTypeChanged",
	PROFILE_REFRESH_REQUESTED: "profile.refreshRequested",
	PROFILE_SAVED: "profile.saved",
	HUB_ANNOUNCEMENT_PROMPTED: "hub.announcementPrompted",
	HUB_ANNOUNCEMENT_OPENED: "hub.announcementOpened",
	HEADER_FRIENDS_OPENED: "header.friendsOpened",
	HEADER_SETTINGS_OPENED: "header.settingsOpened",
	ANNOUNCEMENT_PAGE_SETTINGS_OPENED: "announcement.pageSettingsOpened",
	ANNOUNCEMENT_WIDGET_PICKER_OPENED: "announcement.widgetPickerOpened",
	ANNOUNCEMENT_WIDGET_SELECTED: "announcement.widgetSelected",
	ANNOUNCEMENT_WIDGET_ADDED: "announcement.widgetAdded",
	ANNOUNCEMENT_FUND_OPENED: "announcement.fundOpened",
	ANNOUNCEMENT_SHARE_OPENED: "announcement.shareOpened",
	ANNOUNCEMENT_REGISTRY_OPENED: "announcement.registryOpened",
	GRADFUND_SETUP_SKIPPED: "gradFund.setupSkipped",
	REGISTRY_SETUP_OPENED: "registry.setupOpened",
	REGISTRY_SETUP_CLOSE_REQUESTED: "registry.setupCloseRequested",
	REGISTRY_GOAL_EDITOR_OPENED: "registry.goalEditorOpened",
	REGISTRY_GOAL_SAVED: "registry.goalSaved",
};

export const SPOTLIGHT_SIGNAL_SCOPES = {
	PROFILE: "profile",
	ANNOUNCEMENT: "announcement",
	REGISTRY: "registry",
};
